import { useMutation } from '@tanstack/react-query';

import { verifyOtp } from '@/api/auth';

type UseVerifyOTPProps = {
  onPendingProfileChange?: (pending: boolean) => void;
  onLoggedIn?: () => void;
};

export const useVerifyOTP = ({ onLoggedIn }: UseVerifyOTPProps) => {
  return useMutation({
    mutationFn: verifyOtp,
    onSuccess: () => {
      onLoggedIn?.();
    },
  });
};
